/**
 * "Add the set": picks the variant matching the chosen Size and Framing in every print of the set,
 * shows the total, and adds them all to the cart in one /cart/add.js request.
 */
class FfSetBuilder extends HTMLElement {
  connectedCallback() {
    const ref = (name) => this.querySelector(`[ref="${name}"]`);
    this.form = ref('form');
    this.totalEl = ref('total');
    this.button = ref('button');
    this.error = ref('error');
    this.products = JSON.parse(ref('data').textContent);
    this.moneyFormat = JSON.parse(ref('money').textContent);
    this.form.addEventListener('change', () => this.update());
    this.form.addEventListener('submit', (event) => this.add(event));
    this.update();
  }

  chosen() {
    const data = new FormData(this.form);
    const option1 = data.get('option1');
    const option2 = data.get('option2');
    return this.products.map((p) => p.variants.find((v) => v.option1 === option1 && v.option2 === option2));
  }

  // Swap each print in the strip to the chosen variant's own image (data-ff-frames: {"<size>|<framing>": url, ...}).
  showSelection(size, framing) {
    const key = `${size}|${framing}`;
    for (const img of this.querySelectorAll('img[data-ff-frames]')) {
      let map;
      try { map = JSON.parse(`{${img.dataset.ffFrames.replace(/,\s*$/, '')}}`); } catch { continue; }
      const url = map[key];
      if (!url || img.dataset.ffCurrent === key) continue;
      img.removeAttribute('srcset');
      img.src = url;
      img.dataset.ffCurrent = key;
    }
  }

  formatMoney(cents) {
    const amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return this.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  update() {
    const sel = new FormData(this.form);
    this.showSelection(sel.get('option1'), sel.get('option2'));
    const variants = this.chosen();
    const missing = variants.some((v) => !v || !v.available);
    this.totalEl.textContent = missing ? '' : this.formatMoney(variants.reduce((sum, v) => sum + v.price, 0));
    this.button.disabled = missing;
  }

  async add(event) {
    event.preventDefault();
    const variants = this.chosen();
    if (variants.some((v) => !v)) return;
    this.button.disabled = true;
    this.error.hidden = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: variants.map((v) => ({ id: v.id, quantity: 1 })) }),
      });
      if (!res.ok) throw new Error((await res.json()).description || res.statusText);
      window.location.href = `${window.Shopify?.routes?.root ?? '/'}cart`;
    } catch (e) {
      this.error.textContent = `Couldn't add the set: ${e.message}`;
      this.error.hidden = false;
      this.button.disabled = false;
    }
  }
}

if (!customElements.get('ff-set-builder')) customElements.define('ff-set-builder', FfSetBuilder);
